import { combineReducers } from "redux";

import blog from "../features/blog/Slice";

const BlogData = combineReducers({
  blog: blog,
});

export default BlogData;
